import oRequest from '@/libsV2/request.js';
import store from '@/store/store';


const getData = (url, data) => {
    store.commit("loadSwitch", true);
    return oRequest.getData(url, data).then(res => {
        store.commit("loadSwitch", false);
        return res.data
    })
}


/**
 * 获取勘察报告
 * @param {{accountid: string}} data
 */
// 获取支持人员
export default {

    getSupport : (data) => {
        return getData('hvac/discuss/sysuserlist', data)
    },
    // 获取用户
    getCustomer : (data) => {
        return getData('hvac/discuss/accountlist', data)
        // return, getData('hvac/mapping/accountlist', data)
    },
    // 获取样板间
    getTemplateRoom : (data) => {
        return getData('hvac/discuss/reportexperience', data)
    },
    // 获取样板间时间段
    getReportTime : (data) => {
        return getData('hvac/discuss/reporttime', data)
    },
    // 发送样板间申请
    getReportAppoint : (data) => {
        return getData('hvac/discuss/reportappoint', data)
    },
    // 获取体验间详情
    getTemplateDetail : (data) => {
        return getData('member/project/discussexperience', data)
    },
    // 打卡
    getDiscussSign : (data) => {
        return getData('member/project/discusssign', data)
    },
    // 获取报告信息
    getReportinfo : (data) => {
        return getData('hvac/discuss/reportinfo', data)
    },
    // 获取休息日时间
    getReportRest : (data) => {
        return getData('hvac/discuss/reportrest', data)
    },
    // 获取报告需求
    getReportConfig : (data) => {
        return getData('hvac/discuss/reportconfig', data)
    },
    // 获取2个经纬度距离
    getDistance2 : (data) => {
        return getData('tool/location/distanceget', data)
    },
    // 获取预约列表
    getReportlist : (data) => {
        return getData('hvac/discuss/reportlist', data)
    },
    // 取消预约
    ReportCancel : (data) => {
        return getData('hvac/discuss/reportcancel', data)
    },
    // 取消预约
    getSource : (data) => {
        return getData('hvac/discuss/sourceget', data)
    },
    // 接受邀请
    DiscussAccept : (data) => {
        return getData('member/project/discussaccept', data)
    },
    // 签到
    SignIn : (data) => {
        return getData('hvac/discuss/reportsign', data)
    },
    // 核销
    writeOff : (data) => {
        return getData('hvac/discuss/signcheck', data)
    },
    // 未预约核销
    writeOff2 : (data) => {
        return getData('hvac/discuss/appointscheck', data)
    },
    // 检查当前位置是否可以点击签到
    CheckSignIn : (data) => {
        return getData('hvac/discuss/reportsigncheck', data)
    },
    ReportShare : (data) => {
        return getData('hvac/discuss/reportshare', data)
    },
    getAgreement : (data) => {
        return getData('agree/index/info', data)
    },
    // 取消预约 （潜客）
    cancelAppoint : (data) => {
        return getData('member/project/discusscancel', data)
    },
    // 取消预约（非潜客）
    cancelAppoint2 : (data) => {
        return getData('member/project/discussstaffcancel', data)
    },
    // c端获取报告详情
    getCreportInfoData : (data) => {
        return getData('member/project/discuss', data)
    },
    // 用户分享链接
    userShareUrl : (data) => {
        // return getData('member/index/urls', data)
        return getData('comm/url/urls', data)
    },
    // 一次预约多个时间段
    getReportappoints: (data) => {
        return getData('hvac/discuss/reportappoints', data)
    },
    // 填写超时原因
    Sendreportout: (data) => {
        return getData('hvac/discuss/reportout', data)
    },
    // 获取超时反馈
    getReportfeed: (data) => {
        return getData('hvac/discuss/reportfeedinfo', data)
    },
    // 获取核销页列表
    getSelectList: (data) => {
        return getData('hvac/discuss/reportlist', data)
    },
    // 发送反馈数据
    SendreportFeed: (data) => {
        return getData('hvac/discuss/reportfeed', data)
    },
    // 获取装修公司
    getPosterList: (data) => {
        return getData('act/poster/company', data)
    },
    // 获取周期时间段
    getProjectTime: (data) => {
        return getData('hvac/discuss/projecttime', data)
    },
    // 非潜客人员接受邀请
    DiscussAccept2: (data) => {
        return getData('member/project/discussstaffaccept', data)
    },
    // 预约接口v3
    getAppoint: (data) => {
        return getData('hvac/discuss/reportappointsv3', data)
    },
    // 体验间点检列表
    getCheckList: (data) => {
        return getData('hvac/discuss/projectchecklist', data)
    },
    // 体验间点检搜索
    getProjectpre: (data) => {
        return getData('hvac/discuss/projectpre', data)
    },
    // 体验间点检信息查看
    ProjectCheckInfo: (data) => {
        return getData('hvac/discuss/projectcheckinfo', data)
    },
    // 体验间点检
    ProjectCheck: (data) => {
        return getData('hvac/discuss/projectcheck', data)
    },
    // 体验间点检上传图片
    UploadImg: (data) => {
        return getData('hvac/discuss/uploadimg', data)
    },
    // 体验间身份识别
    getIdentity: (data) => {
        return getData('user/index/index', data)
    },
    // 获取负责的体验间
    ProjectGroup: (data) => {
        return getData('hvac/discuss/projectgroup', data)
    },
    // 体验间不点检提交
    ProjectUncheck: (data) => {
        return getData('hvac/discuss/projectuncheck', data)
    },
    // 体验间不点检提交
    writeOffList: (data) => {
        return getData('hvac/discuss/signlist', data)
    },
}
